import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import {
  FormDropDownList,
  FormDropDownListById,
  FormInput,
  FormTextArea,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showHideGoogleSheets } from "../../../../redux/slices/createschedulepageslice";
import { useEffect } from "react";
import { widgetAllAggregateFunctions } from "../../../../components/widgets/utils";

const GeneralStep = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const pageState = useSelector((state) => state.createSchedulePage);
  const currentTheme = useSelector((state) => state.currentTheme);
  const listOfFiles =
    pageState.formValues.GoogleList?.filter((f) => f.IsSheet) ?? [];

  const ddlType = [
    { Id: 0, Title: t("schedule.select") },
    //{ Id: 1, Title: "Pdf" },
    { Id: 2, Title: t("schedule.excel") },
  ];

  const ddlSource = [
    { Id: 0, Title: t("schedule.select") },
    { Id: 1, Title: t("schedule.google_sheets") },
    // { Id: 2, Title: "Https" },
    // { Id: 3, Title: "SFTP" },
    // { Id: 4, Title: "Email" },
  ];

  useEffect(() => {
    const source = pageState.formValues.Source;
    dispatch(showHideGoogleSheets(source === 1 || source === "1"));
    if (source === 1 || source === "1") {
      props.loadGoogleConnections(t);
    }
  }, [pageState.formValues.Source]);

  useEffect(() => {
    if (pageState.formValues.ConnectionId) {
      props.loadGoogleConnectorSheets(t);
    }
  }, [pageState.formValues.ConnectionId]);

  useEffect(() => {
    if (pageState.formValues.SheetName) {
      props.getGoogleSheetId(
        pageState.formValues.File,
        pageState.formValues.SheetName,
        pageState.formValues.FilePath,
        pageState.formValues.ConnectionId,
        t,
      );
    }
  }, [pageState.formValues.SheetName]);

  const customFields = [...(pageState.formValues.CustomFields ?? [])];

  const updateCustomField = (index, key, value) => {
    const updated = customFields.map((item, i) =>
      i === index ? { ...item, [key]: value } : item,
    );

    props.onChangeFormValue("CustomFields", updated, props.onChange);
  };

  const addCustomField = () => {
    const updated = [
      ...customFields,
      { index: customFields.length + 1, field: "", value: "" },
    ];
    props.onChangeFormValue("CustomFields", updated, props.onChange);
  };

  const removeCustomField = (indexToRemove) => {
    const updated = customFields
      .filter((_, i) => i !== indexToRemove)
      .map((item, i) => ({ ...item, index: i + 1 }));
    props.onChangeFormValue("CustomFields", updated, props.onChange);
  };

  return (
    <FormRegion>
      <div className="form-group form-group-1 stepper-rd-btns">
        <div className="dataset-info">
          <Field
            id={"Name"}
            name={"Name"}
            label={t("schedule.name")}
            component={FormInput}
            maxLength={255}
            onChange={(e) =>
              props.onChangeFormValue("Name", e.value, props.onChange)
            }
          />
          <Field
            id={"Description"}
            name={"Description"}
            label={t("schedule.description")}
            component={FormTextArea}
            style={{ height: 80 }}
            onChange={(e) =>
              props.onChangeFormValue("Description", e.value, props.onChange)
            }
          />

          <Field
            id={"Type"}
            name={"Type"}
            label={t("schedule.type")}
            component={FormDropDownListById}
            data={ddlType}
            dataItemKey="Id"
            textField="Title"
            value={pageState.formValues.Type}
            onChange={(e) =>
              props.onChangeFormValue("Type", e.value, props.onChange)
            }
          />

          <Field
            id={"Source"}
            name={"Source"}
            label={t("schedule.source")}
            component={FormDropDownListById}
            data={ddlSource}
            dataItemKey="Id"
            textField="Title"
            value={pageState.formValues.Source}
            onChange={(e) => {
              props.onChangeFormValue("Source", e.value, props.onChange);
              props.onChangeFormValue("File", "", props.onChange);
            }}
          />

          {pageState.formValues.ShowGoogleSheets && (
            <>
              <Field
                id={"Connections"}
                name={"Connections"}
                label={t("connection.connection")}
                component={FormDropDownListById}
                data={pageState.formValues.Connections}
                dataItemKey="ConnectionId"
                textField="ConnectionTitle"
                value={pageState.formValues.ConnectionId}
                onChange={(e) => {
                  props.onChangeFormValue(
                    "ConnectionId",
                    e.value,
                    props.onChange,
                  );
                }}
              />
            </>
          )}
          {pageState.formValues.ConnectionId && (
            <>
              <Field
                id={"File"}
                name={"File"}
                label={t("schedule.file")}
                component={FormDropDownListById}
                data={listOfFiles}
                dataItemKey="SheetId"
                textField="FilePath"
                value={pageState.formValues.File}
                onChange={(e) => {
                  const file = listOfFiles.find((f) => f.SheetId == e.value);
                  props.onChangeFormValue("File", e.value, props.onChange);
                  props.onChangeFormValue("SheetId", e.value, props.onChange);
                  props.onChangeFormValue(
                    "FilePath",
                    file.FilePath,
                    props.onChange,
                  );
                  props.onChangeFormValue("SheetName", "", props.onChange);
                }}
              />
            </>
          )}
          {pageState.formValues.File && (
            <Field
              id="SheetName"
              name="SheetName"
              label={t("schedule.sheetname")}
              component={FormDropDownList}
              data={
                pageState.formValues.GoogleList?.find(
                  (e) => e.SheetId === pageState.formValues.File,
                )?.SheetNames || []
              }
              value={pageState.formValues.SheetName}
              onChange={(e) =>
                props.onChangeFormValue("SheetName", e.value, props.onChange)
              }
            />
          )}

          {pageState.formValues.GoogleSheetId > 0 && (
            <>
              {/* Add */}
              <button
                type="button"
                onClick={addCustomField}
                style={{
                  padding: "6px 20px",
                  color: currentTheme.touchColor,
                  fontWeight: 500,
                  marginTop: "20px",
                  border: `1px solid rgba(0, 0, 0, 0.06)`,
                  borderRadius: "5px",
                  width: "fit-content",
                  float: "right",
                }}
              >
                + {t("schedule.add")}
              </button>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  width: "100%",
                }}
              >
                {customFields.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: 12,
                      width: "100%",
                      alignItems: "flex-end",
                    }}
                  >
                    <div style={{ width: 30, fontWeight: 600 }}>
                      {item.index}.
                    </div>
                    <Field
                      //name={`CustomFields[${index}].field`}
                      label={t("schedule.customField")}
                      //defaultValue={item.field}
                      component={FormDropDownList}
                      data={pageState.formValues.ColumnNames}
                      style={{
                        flex: 1,
                        width: "350px",
                        height: "34px",
                      }}
                      onChange={(e) =>
                        updateCustomField(index, "field", e.value)
                      }
                    />

                    <Field
                      //name={`CustomFields[${index}].value`}
                      label={t("schedule.customFieldValue")}
                      component={FormInput}
                      maxLength={255}
                      //defaultValue={item.value}
                      style={{
                        flex: 1,
                        width: "350px",
                        marginTop: "0",
                      }}
                      onChange={(e) =>
                        updateCustomField(index, "value", e.value)
                      }
                    />

                    <button
                      type="button"
                      onClick={() => removeCustomField(index)}
                      style={{
                        height: 34,
                        alignSelf: "flex-end",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      ❌
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </FormRegion>
  );
};

export default GeneralStep;
